<template>
  <div class="card">
    <div v-if="title" class="card-header">
      <span class="align-self-center">{{ title }}</span>
      <v-button v-if="buttonText" :loading="buttonBusy" :block="false" :type="buttonType" nativeType="button" :class="'float-right'" :click="onclicked">{{ $t(buttonText) }}</v-button>
    </div>

    <div class="card-body">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',

  props: {
    title: { type: String, default: null },

    buttonText: { type: String, default: null },
    buttonType:{type: String, default: 'outline-primary'},
    buttonBusy: {type: Boolean, default: false},
    onclicked: {type: Function, default: ()=>{}}
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/Card.vue